(function () {
	const AUTOPLAY_DELAY = 5000;
	const TRANSITION_MS = 600;
	const GAP = 24;
	const OPACITY_CENTER = 1;
	const OPACITY_NEIGHBOR = 0.3;
	const OPACITY_OTHER = 0.3;

	function initCarousel(root) {
		const list = root.querySelector(".comments-list");
		const leftBtn = root.querySelector(".left-button");
		const rightBtn = root.querySelector(".right-button");
		if (!list) return;
		if (root.__carouselInitialized) return;
		root.__carouselInitialized = true;

		let items = Array.from(list.querySelectorAll(".comment-item"));
		if (!items.length) return;

		const carousel = root; // root is the .comments-carousel already
		const visibleWidth = carousel.offsetWidth;
		const itemWidth = items[0].offsetWidth;
		const visibleCount = Math.ceil(visibleWidth / (itemWidth + GAP)) + 1;

		const clonesBefore = visibleCount;
		const clonesAfter = visibleCount;
		const originals = items.slice();
		const totalOriginals = originals.length;

		// Remove any old clones and clear transforms (clean start)
		list.querySelectorAll(".carousel-clone").forEach((n) => n.remove());
		list.style.transition = "none";
		list.style.transform = "";

		// Prepend clones of the last items
		originals
			.slice(-clonesBefore)
			.reverse()
			.forEach((el) => {
				const clone = el.cloneNode(true);
				clone.classList.add("carousel-clone");
				list.insertBefore(clone, list.firstChild);
			});

		// Append clones of the first items
		originals.slice(0, clonesAfter).forEach((el) => {
			const clone = el.cloneNode(true);
			clone.classList.add("carousel-clone");
			list.appendChild(clone);
		});

		items = Array.from(list.querySelectorAll(".comment-item"));
		let index = clonesBefore;

		list.style.willChange = "transform";
		items.forEach((it) => {
			it.style.transition = `opacity ${TRANSITION_MS}ms ease, transform ${TRANSITION_MS}ms ease`;
			it.style.boxSizing = it.style.boxSizing || "border-box";
		});

		// Keep handler references for teardown
		const handlers = {
			onTransitionEnd: null,
			onLeftClick: null,
			onRightClick: null,
			onMouseEnter: null,
			onMouseLeave: null,
		};

		function updateOpacities(currentIndex) {
			const currentLogical =
				(currentIndex - clonesBefore + totalOriginals) % totalOriginals;
			items.forEach((item, i) => {
				const iLogical = (i - clonesBefore + totalOriginals) % totalOriginals;
				let dist = Math.abs(iLogical - currentLogical);
				if (dist > totalOriginals / 2) dist = totalOriginals - dist;

				if (dist === 0) {
					item.style.opacity = OPACITY_CENTER;
				} else if (dist === 1) {
					item.style.opacity = OPACITY_NEIGHBOR;
				} else {
					item.style.opacity = OPACITY_OTHER;
				}
			});
		}

		function applyTransform(idx, withTransition = true) {
			// recalc container width in case it changed since init
			const containerWidth = carousel.offsetWidth;
			const offset =
				(itemWidth + GAP) * idx - containerWidth / 2 + itemWidth / 2;

			list.style.transition = withTransition
				? `transform ${TRANSITION_MS}ms ease`
				: "none";
			list.style.transform = `translateX(-${offset}px)`;
			updateOpacities(idx);
		}

		function handleTransitionEnd() {
			const firstOriginal = clonesBefore;
			const lastOriginal = clonesBefore + totalOriginals - 1;

			if (index > lastOriginal) {
				index = firstOriginal + ((index - firstOriginal) % totalOriginals);
				applyTransform(index, false);
			} else if (index < firstOriginal) {
				const offsetFromFirst = firstOriginal - index;
				index = lastOriginal - ((offsetFromFirst - 1) % totalOriginals);
				applyTransform(index, false);
			}
		}

		function move(dir) {
			index += dir;
			applyTransform(index, true);
		}

		// store bound handlers so we can remove them later
		handlers.onLeftClick = () => move(-1);
		handlers.onRightClick = () => move(1);
		handlers.onTransitionEnd = handleTransitionEnd;
		handlers.onMouseEnter = () => clearInterval(autoplayId);
		handlers.onMouseLeave = () => {
			clearInterval(autoplayId);
			autoplayId = setInterval(() => move(1), AUTOPLAY_DELAY);
		};

		if (leftBtn) leftBtn.addEventListener("click", handlers.onLeftClick);
		if (rightBtn) rightBtn.addEventListener("click", handlers.onRightClick);
		list.addEventListener("transitionend", handlers.onTransitionEnd);
		root.addEventListener("mouseenter", handlers.onMouseEnter);
		root.addEventListener("mouseleave", handlers.onMouseLeave);

		let autoplayId = setInterval(() => move(1), AUTOPLAY_DELAY);

		// initial position
		applyTransform(index, false);

		// teardown & reinit helper used on resize
		function teardown() {
			// remove clones
			list.querySelectorAll(".carousel-clone").forEach((n) => n.remove());
			// remove listeners
			if (leftBtn) leftBtn.removeEventListener("click", handlers.onLeftClick);
			if (rightBtn)
				rightBtn.removeEventListener("click", handlers.onRightClick);
			list.removeEventListener("transitionend", handlers.onTransitionEnd);
			root.removeEventListener("mouseenter", handlers.onMouseEnter);
			root.removeEventListener("mouseleave", handlers.onMouseLeave);
			// clear autoplay
			clearInterval(autoplayId);
			// reset flag
			root.__carouselInitialized = false;
		}

		// Handle resize by full reinit
		let resizeTimer;
		const onResize = () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				teardown();
				// small timeout to allow DOM to settle, then re-init
				setTimeout(() => initCarousel(root), 50);
			}, 200);
		};
		window.addEventListener("resize", onResize);

		// store resize listener reference to remove later if you extend teardown
		root.__carousel_teardown = () => {
			window.removeEventListener("resize", onResize);
			teardown();
		};
	}

	document.addEventListener("DOMContentLoaded", () => {
		document.querySelectorAll(".comments-carousel").forEach(initCarousel);
	});
})();
